module.exports = require("ramda/src/filter");